module.exports = __webpack_public_path__ + "img/ÜbungsdiensteFeb23.b4eb7924.jpg";